import { alertConstants } from '@constants/alert';
import { currentHistoryEntry } from '@helpers/navigation';

export const alertActions = {
    success,
    error,
    clear,
    clearAll,
    clearOtherPages,
};

function success(message, options) {
    return { type: alertConstants.SUCCESS, message, historyEntry: currentHistoryEntry(), ...options };
}

function error(message, options) {
    return { type: alertConstants.ERROR, message, historyEntry: currentHistoryEntry(), ...options };
}

function clear(id) {
    return { type: alertConstants.CLEAR, id };
}

function clearAll() {
    return { type: alertConstants.CLEAR_ALL };
}

function clearOtherPages(historyEntry) {
    return { type: alertConstants.CLEAR_OTHER_PAGES, historyEntry };
}
